import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";

import { ListHeaderAttributeComponent, ListHeaderAttributeComponentProps } from "@multiweb/reactComponents";
import {
    createFetchAttributesLocalizationsKey,
    createGetAttributeOrderBySelector,
    createToggleOrderByAction,
} from "@multiweb/reactCore/datasource";
import { isFetching } from "@multiweb/reactCore/fetching";
import { IAppState } from "@multiweb/types/react";
import { getAtributePrimaryText, getAtributeSecondaryText, getInteractive } from "../../selectors";

export type ListHeaderAttributeProps = {
    /** Unikátní klíč pro DataSource. */
    dataSourceKey: string;
    /** Obsahuje informace potřebné k zobrazení atributu. */
    attributeName: string;
};

type StateProps = Pick<
    ListHeaderAttributeComponentProps,
    "attributeName" | "attributeTitle" | "orderType" | "isLocalizationsFetching" | "interactive"
>;

const createMapStateToProps: (
    state: IAppState,
    props: ListHeaderAttributeProps,
) => MapStateToProps<StateProps, ListHeaderAttributeProps, IAppState> = (_state, { attributeName }) => {
    const getAttributeOrderBy = createGetAttributeOrderBySelector(attributeName);

    return (state, { dataSourceKey, attributeName }) => ({
        attributeName: getAtributePrimaryText(state, { dataSourceKey, attributeName }),
        attributeTitle: getAtributeSecondaryText(state, { dataSourceKey, attributeName }),
        orderType: getAttributeOrderBy(state, dataSourceKey),
        isLocalizationsFetching: isFetching(state, createFetchAttributesLocalizationsKey(dataSourceKey)),
        interactive: getInteractive(state, dataSourceKey),
    });
};

type DispatchProps = Pick<ListHeaderAttributeComponentProps, "onClick" | "onShiftClick">;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, ListHeaderAttributeProps> = (
    dispatch,
    { dataSourceKey, attributeName },
) => ({
    onClick: () => dispatch(createToggleOrderByAction(dataSourceKey, attributeName, true)),
    onShiftClick: () => dispatch(createToggleOrderByAction(dataSourceKey, attributeName, false)),
});

export const ListHeaderAttribute = connect(createMapStateToProps, mapDispatchToProps)(ListHeaderAttributeComponent);
